import axios from "axios";
import qs from "qs";
import { saveAs } from "file-saver";
import { Message, Loading } from "element-ui";
import { Toast, Notify } from "vant";
import router from "@/router";
import store from "@/store";
import { isArray } from "@/utils/commonTools";
import {
  requestTimeout,
  contentType,
  successCode,
  invalidCode,
  unauthorizedCode,
  noPermissionCode,
  needOtpCode,
  recordRoute,
  loginInterception,
} from "@/setting.config";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: requestTimeout,
  headers: {
    "Content-Type": contentType,
  },
});
// let loading;
// let needLoadingRequestCount = 0;
// const startLoading = () => {
//   needLoadingRequestCount++
//   loading = Loading.service({
//     lock: true,
//     text: '处理中……',
//     background: 'rgba(255,255,255, 0.5)'
//   })
// }
// const endLoading = () => {
//   needLoadingRequestCount--
//   if(needLoadingRequestCount<=0){
//     loading.close()
//   }
// }

/**
 * 处理code异常
 * @param {*} code
 * @param {*} msg
 */
const handleCode = (code, msg) => {
  switch (code) {
    case invalidCode:
      reportError(msg || `后端接口${code}异常`);
      store.dispatch("user/resetAccessToken");
      if (loginInterception) {
        location.reload();
      }
      break;
    case unauthorizedCode:
      // store.getters["user/accessToken"] &&
      localStorage.removeItem("accountInfo");
      store.commit("user/setInfo", null);
      setTimeout(() => {
        const isMobile = store.getters["app/isMobileMode"];
        if (recordRoute) {
          const fullPath = router.currentRoute.fullPath;
          if (isMobile) {
            router.push(`/h5/login?redirect=${fullPath}`);
          } else {
            router.push(`/login?redirect=${fullPath}`);
          }
        } else {
          if (isMobile) {
            router.push("/h5/Home");
          } else {
            router.push("/Home");
          }
        }
      }, 500);
      break;
    case noPermissionCode:
      reportError(msg || "无权限进行操作");
      break;
    case needOtpCode:
      break;
    default:
      reportError(msg || `后端接口${code}异常`);
      break;
  }
};

instance.interceptors.request.use(
  (config) => {
    // startLoading();
    if (!config.headers || !config.headers.Authorization) {
      const accessToken = store.getters["user/accessToken"];
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }
    }
    if (
      config.data &&
      config.headers["Content-Type"] ===
        "application/x-www-form-urlencoded;charset=UTF-8"
    )
      config.data = qs.stringify(config.data);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // endLoading();
    const { data, config, headers } = response;
    const { code, msg } = data;
    // 附件下载
    if (
      response &&
      response.status == 200 &&
      response.headers &&
      response.headers["content-disposition"] &&
      response.headers["content-disposition"].startsWith("attachment;")
    ) {
      let blob = new Blob([response.data]);
      const fileName = decodeURIComponent(
        response.headers["content-disposition"]
          .split(";")[1]
          .split("filename=")[1]
      );
      saveAs(blob, fileName);
    }

    // TODO：暂时允许请求不返回code
    if (code === undefined) {
      return data;
    }

    console.log('code === 302 &&"操作成功" === msg',code === 302 &&"操作成功" === msg)
    if(code === 302 &&"操作成功" === msg ){
      return data;
    }

    // // 操作正常Code数组
    const codeVerificationArray = isArray(successCode)
      ? [...successCode]
      : [...[successCode]];
    // 是否操作正常
    if (codeVerificationArray.includes(code)) {
      return data;
    } else {
      handleCode(code, msg || data.message);
      return Promise.reject(data);
    }
  },
  (error) => {
    // endLoading();
    if (error?.response?.data instanceof Blob) {
      const reader = new FileReader();
      reader.onload = function () {
        const jsonData = JSON.parse(reader.result);
        console.log(jsonData);
        reportError(jsonData.message || `后端接口未知异常`);
      };
      reader.readAsText(error.response.data);
      return Promise.reject(error);
    }

    const { response, message } = error;
    if (response) {
      const { status, data } = response;
      handleCode(status, data?.message || message);
      return Promise.reject(data);
    } else {
      let { message } = error;
      if (message === "Network Error") {
        message = "后端接口连接异常";
      }
      if (message.includes("timeout")) {
        message = "后端接口请求超时";
      }
      if (message.includes("Request failed with status code")) {
        const code = message.substr(message.length - 3);
        message = "后端接口" + code + "异常";
      }
      // Vue.prototype.$baseMessage(message || `后端接口未知异常`, 'error')
      reportError(message || `后端接口未知异常`);
      return Promise.reject(error);
    }
  }
);

function reportError(error) {
  // Send error report to an external service
  const isMobile = store.getters["app/isMobileMode"];
  if (isMobile) {
    Toast.fail(error);
  } else {
    Message.error(error);
  }
}
export default instance;
